module.exports = __webpack_public_path__ + "img/anejo-14-estudiantes-por-especialista.0742bdce.svg";